(() => {
  const SELECTORS = [
    '[data-testid="klaviyo-form-modal"]',
    '[data-testid="klaviyo-form"]',
    '.klaviyo-form',
    '[class*="klaviyo-form"]'
  ];
  const SELECTOR_LIST = SELECTORS.join(',');
  const PADDING = 32;
  const MAX_RETRIES = 6;

  const isElement = (node) => node && node.nodeType === 1;

  const getPopupRoot = (el) => {
    if (!el || !el.closest) return null;
    const modal = el.closest('[data-testid="klaviyo-form-modal"], [aria-modal="true"], [role="dialog"]');
    if (modal) return modal;
    try {
      const pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'absolute') return el;
    } catch (e) {}
    return null;
  };

  const getPopupContent = (root) => {
    if (!root) return null;
    const direct = root.querySelector('[data-testid="klaviyo-form"], .klaviyo-form, [class*="klaviyo-form"]');
    return direct || root;
  };

  const isModalRoot = (root) => {
    if (!root || !root.matches) return false;
    return root.matches('[data-testid="klaviyo-form-modal"], [aria-modal="true"], [role="dialog"]');
  };

  const applyRootLayout = (root, isMobile) => {
    if (!isModalRoot(root)) return;
    if (isMobile) {
      root.style.padding = '';
      root.style.boxSizing = '';
      root.style.maxWidth = '';
      root.style.maxHeight = '';
      return;
    }
    root.style.boxSizing = 'border-box';
  };

  const fitPopup = (root, attempt = 0) => {
    if (!root || !document.body.contains(root)) return;
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    applyRootLayout(root, isMobile);
    const content = getPopupContent(root);
    if (!content) return;

    if (!content.dataset.klaviyoBaseTransform) {
      const computed = window.getComputedStyle(content).transform;
      content.dataset.klaviyoBaseTransform = computed && computed !== 'none' ? computed : 'none';
    }

    const baseTransform = content.dataset.klaviyoBaseTransform || 'none';
    if (isMobile) {
      content.style.maxWidth = '';
      content.style.maxHeight = '';
      content.style.overflow = '';
      content.style.boxSizing = '';
      content.style.transformOrigin = '';
      content.style.transform = baseTransform === 'none' ? '' : baseTransform;
      return;
    }

    content.style.maxWidth = '';
    content.style.maxHeight = '';
    content.style.boxSizing = 'border-box';
    content.style.overflow = '';
    content.style.transformOrigin = 'center center';
    content.style.transform = baseTransform === 'none' ? '' : baseTransform;

    const rect = content.getBoundingClientRect();
    if (rect.width < 10 || rect.height < 10) {
      if (attempt < MAX_RETRIES) {
        requestAnimationFrame(() => fitPopup(root, attempt + 1));
      }
      return;
    }

    const scaleX = (window.innerWidth - PADDING * 2) / rect.width;
    const scaleY = (window.innerHeight - PADDING * 2) / rect.height;
    const scale = Math.min(1, scaleX, scaleY);

    if (scale < 1) {
      content.style.transform = baseTransform === 'none'
        ? `scale(${scale})`
        : `${baseTransform} scale(${scale})`;
    } else {
      content.style.transform = baseTransform === 'none' ? '' : baseTransform;
    }
  };

  const scan = () => {
    document.querySelectorAll(SELECTOR_LIST).forEach((el) => {
      if (!isElement(el)) return;
      const root = getPopupRoot(el);
      if (!root) return;
      fitPopup(root);
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes) continue;
      for (const node of mutation.addedNodes) {
        if (!isElement(node)) continue;
        if (node.matches?.(SELECTOR_LIST) || node.querySelector?.(SELECTOR_LIST)) {
          requestAnimationFrame(scan);
          return;
        }
      }
    }
  });

  const boot = () => {
    if (!document.body) return;
    scan();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scan, 150);
  });
})();
